import Header from "component/Header/index";
import { useEffect, useMemo, useState } from "react";
import { Layout, Menu } from "antd";
import { HomeOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import IcRoot from "@iso/assets/images/icon_settings_bo.png";
import IcStore from "@iso/assets/images/icon_store_bo.png";
import IcProduct from "@iso/assets/images/icon_product_bo.png";
import IcAuthorization from "@iso/assets/images/icon_authorization_bo.png";
import styled from "styled-components";
import useAuthor from "hooks/useAuthor";
import { useOidc, useOidcUser } from "@iso/helpers/oidc";
import roleApi from "../../api/roleApi";
import storeApi from "../../api/storeApi";

const { Content, Sider } = Layout;

const SiderFood = styled.a`
   position: fixed;
   bottom: 48px;
   left: 0;
   width: 200px;
   padding: 12px;
   font-size: 14px;
   color: white;
   /* text-align: center; */
   display: flex;
   gap: 8px;
   /* justify-content: center; */
   align-items: center;
   &:hover {
      background: #242e52;
   }
`;

function MainLayout(props) {
   const { children } = props;
   const { checkRoles } = useAuthor();
   const { oidcUser } = useOidcUser();
   const { isAuthenticated } = useOidc();
   const [user, setUser] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const history = useHistory();
   const [collapsed, setCollapsed] = useState(
      window.screen.width > 426 ? false : true
   );

   useEffect(() => {
      if (oidcUser) {
         initUser();
      }
   }, [oidcUser]);

   const loadRoles = async () => {
      const roles = await roleApi.getRolesByUserId();
      let permissions = {};
      if (roles && roles.length) {
         roles.forEach((role) => {
            role.extraProperties?.permissions?.forEach((permission) => {
               permissions[permission] = true;
            });
         });
      }

      return permissions;
   };

   const initUser = async () => {
      setIsLoading(true);
      const stores = await storeApi.getStoresByUserId(oidcUser.sub);

      setUser({
         ...user,
         info: oidcUser,
         permissions: await loadRoles(),
         store: {
            list: stores,
            current: stores.length ? stores[0] : null,
         },
         isLogin: isAuthenticated,
      });
      setIsLoading(false);
   };

   const reloadRoles = async () => {
      setIsLoading(true);
      let permissions = await loadRoles();
      setUser({
         ...user,
         permissions,
      });
      setIsLoading(false);
   };

   const reloadStores = async () => {
      setIsLoading(true);
      const stores = await storeApi.getStoresByUserId(oidcUser.sub);
      setUser({
         ...user,
         store: {
            ...user.store,
            list: stores,
            current: stores?.find(
               (store) => store.code === user?.store?.current?.code
            ),
         },
      });
      setIsLoading(false);
   };

   return (
      <UserContext.Provider
         value={{ user, isLoading, initUser, reloadRoles, reloadStores }}
      >
         <div className="fade-in">
            <Layout>
               <Sider
                  collapsedWidth={window.screen.width > 426 ? 80 : 0}
                  collapsible
                  collapsed={collapsed}
                  className="wrapper-sidebar-menu"
                  onCollapse={(value) => setCollapsed(value)}
               >
                  <div className="logo " style={{ height: 65 }}>
                     <Link to="/">4P's</Link>
                     <button onClick={() => setCollapsed(true)}>
                        <MenuUnfoldOutlined />
                     </button>
                  </div>
                  <Menu
                     theme="dark"
                     mode="inline"
                     className="wrapper-custom-sidebar"
                  >
                     <Menu.Item
                        className={
                           history.location.pathname === "/store"
                              ? "active-menu"
                              : ""
                        }
                        icon={
                           <img
                              src={IcStore}
                              style={{ maxWidth: 26, marginRight: 8 }}
                              alt="icon-root"
                           />
                        }
                     >
                        <Link to="/store">Store</Link>
                     </Menu.Item>
                     {user && user.permissions?.["BackOfficeMenu.IAM"] && (
                        <Menu.SubMenu
                           title="IAM"
                           icon={
                              <img
                                 src={IcAuthorization}
                                 style={{ maxWidth: 21, marginRight: 8 }}
                                 alt="icon-root"
                              />
                           }
                        >
                           <Menu.Item
                              key="6"
                              className={
                                 history.location.pathname ===
                                 "/root/staff-setting"
                                    ? "active-menu"
                                    : ""
                              }
                           >
                              <Link to="/root/staff-setting">Staffs</Link>
                           </Menu.Item>
                           <Menu.Item
                              key="7"
                              className={
                                 history.location.pathname ===
                                 "/root/group-role"
                                    ? "active-menu"
                                    : ""
                              }
                           >
                              <Link to="/root/group-role">Roles</Link>
                           </Menu.Item>
                        </Menu.SubMenu>
                     )}
                     {/* <Menu.Item
                     className={
                        history.location.pathname === "/schedule-surcharge"
                           ? "active-menu"
                           : ""
                     }
                     icon={
                        <img
                           src={IcStore}
                           style={{ maxWidth: 26, marginRight: 0 }}
                           alt="icon-root"
                        />
                     }
                  >
                     <Link to="/schedule-surcharge">Surcharge Schedule</Link>
                  </Menu.Item>  */}
                  </Menu>
                  <SiderFood
                     href="/mms/choose-system"
                     style={{ width: collapsed ? 80 : 200 }}
                  >
                     <HomeOutlined
                        className={`${collapsed ? "mx-auto" : ""}`}
                     />
                     {!collapsed && <span>Back to Homepage</span>}
                  </SiderFood>
               </Sider>
               <Layout className="site-layout">
                  <Header />
                  <Content>{children}</Content>
               </Layout>
            </Layout>
         </div>
      </UserContext.Provider>
   );
}

export default MainLayout;
